import * as React from 'react';

import { useAuthToken } from '../auth/entraAuthConfig';
import { setupCableConsumer } from '../utils/actioncable';

const useActionCableConsumer = () => {
  const { idToken } = useAuthToken();

  const [[token, currentCable], setCurrentCable] = React.useState(() => [idToken, setupCableConsumer(idToken)]);

  React.useEffect(() => {
    if (idToken !== token) {
      setCurrentCable(([_, previousCable]) => {
        previousCable?.disconnect();

        return [idToken, setupCableConsumer(idToken)];
      });
    }
  }, [idToken, token, currentCable]);

  return currentCable;
};

export default useActionCableConsumer;
